/*eslint  @typescript-eslint/no-use-before-define: 0*/

import _ from "lodash";
import i18n from "@/plugins/i18n";
import {
  changePayer,
  setStatusToScam,
  cancelScamStatus,
  getCostDocumentsOther,
  removeCostDocumentOther,
  approveCostDocumentOther,
  approveCostDocumentsOther,
  getCostDocumentOtherItems,
  getCostDocumentOtherFiles,
  getCostDocumentOtherDetails,
  getCostDocumentsOtherFiltered,
  changeCategory,
} from "@/requests/costDocumentOther";
import { DataOptions } from "vuetify";
import { defineModule } from "direct-vuex";
import { FileGuid } from "@/models/api/Files";
import { FILTER_NAMES } from "@/static/filterNames";
import { SelectItem } from "@/models/api/SelectItem";
import { assignCostDocument } from "@/requests/buffer";
import { filterCapitalize } from "@/filters/capitalize";
import { DoubleConfirm } from "@/models/api/DoubleConfirm";
import { SERVICE_CATEGORY } from "@/static/serviceCategory";
import { getServiceTypesSimple } from "@/requests/serviceType";
import { ConfirmModel } from "@/models/components/popup/Confirm";
import { COST_DOCUMENT_TYPES } from "@/static/costDocumentTypes";
import { moduleActionContext, moduleGetterContext } from "@/store";
import { COST_DOCUMENT_CONTROLLERS } from "@/static/costDocumentControllers";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { CostDocumentDetails } from "@/models/api/costDocuments/CostDocumentDetails";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { CostDocumentOtherItem } from "@/models/api/costDocumentsOther/CostDocumentOtherItem";
import costDocumentsOtherEditor from "@/store/modules/costDocumentsOther/costDocumentsOtherEditor";
import {
  CostDocumentOther,
  CostDocumentOtherFiltered,
  CostDocumentOtherResponse,
} from "@/models/api/costDocumentsOther/CostDocumentOther";
export interface CostDocumentsOtherStateInterface {
  otherList: Array<CostDocumentOther>;
  otherCount: number;
  otherOptions: DataOptions;
  otherFilters: Array<CriterionItemRequest> | null;
  selectedOther: CostDocumentOther | null;
  isOtherLoading: boolean;
  otherItems: Array<CostDocumentOtherItem>;
  isOtherItemsLoading: boolean;
  otherFiles: Array<FileGuid> | null;
  otherDetails: CostDocumentDetails | null;
  otherForScam: CostDocumentOther | null;
  otherMarked: Array<CostDocumentOtherFiltered>;
  activeView: COST_DOCUMENT_CONTROLLERS;
  filterName: string;
  contractorContractFilterName: string;
  serviceTypes: Array<SelectItem>;
}

export const CostDocumentsOtherState: CostDocumentsOtherStateInterface = {
  otherList: [],
  otherCount: 0,
  otherOptions: new DefaultDataOptions(),
  otherFilters: null,
  selectedOther: null,
  isOtherLoading: false,
  otherItems: [],
  isOtherItemsLoading: false,
  otherFiles: null,
  otherDetails: null,
  otherForScam: null,
  otherMarked: [],
  activeView: COST_DOCUMENT_CONTROLLERS.Other,
  filterName: FILTER_NAMES.CostDocumentOtherStandardFilter,
  contractorContractFilterName: FILTER_NAMES.ContractByContractorFilter,
  serviceTypes: [],
};

const CostDocumentsOtherModule = defineModule({
  state: CostDocumentsOtherState as CostDocumentsOtherStateInterface,
  modules: {
    editor: costDocumentsOtherEditor,
  },
  namespaced: true as const,
  getters: {},
  mutations: {
    setOtherList(state, param: CostDocumentOtherResponse) {
      state.otherList = param.items;
      state.otherCount = param.totalCount;
    },
    setOtherOptions(state, param: DataOptions) {
      state.otherOptions = JSON.parse(JSON.stringify(param));
    },
    setOtherFilters(state, param: Array<CriterionItemRequest>) {
      state.otherFilters = param;
    },
    setSelectedOther(state, param: CostDocumentOther | null) {
      state.selectedOther = param;
    },
    setIsOtherLoading(state, param: boolean) {
      state.isOtherLoading = param;
    },
    setOtherItems(state, param: Array<CostDocumentOtherItem>) {
      state.otherItems = param;
    },
    setIsOtherItemsLoading(state, param: boolean) {
      state.isOtherItemsLoading = param;
    },
    setOtherFiles(state, param: Array<FileGuid> | null) {
      state.otherFiles = param;
    },
    setOtherDetails(state, param: CostDocumentDetails | null) {
      state.otherDetails = param;
    },
    setOtherForScam(state, param: CostDocumentOther | null) {
      state.otherForScam = param;
    },
    setOtherMarked(state, param: Array<CostDocumentOtherFiltered>) {
      state.otherMarked = param;
    },
    setActiveView(state, param: COST_DOCUMENT_CONTROLLERS) {
      if (state.activeView === param) return;
      state.activeView = param;
      state.filterName =
        param === COST_DOCUMENT_CONTROLLERS.Other
          ? FILTER_NAMES.CostDocumentOtherStandardFilter
          : FILTER_NAMES.CommercialCostStandardFilter;
      state.contractorContractFilterName =
        param === COST_DOCUMENT_CONTROLLERS.Other
          ? FILTER_NAMES.ContractByContractorFilter
          : FILTER_NAMES.CommercialContractByContractorFilter;
      state.otherOptions = new DefaultDataOptions();
      state.otherCount = 0;
      state.otherItems = [];
      state.otherDetails = null;
      state.otherFiles = null;
      state.selectedOther = null;
      state.otherForScam = null;
      state.otherMarked = [];
    },
    setServiceTypes(state, param: Array<SelectItem>) {
      state.serviceTypes = param;
    },
  },
  actions: {
    async getCostDocumentsOther(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsOtherLoading(true);
      const response = await getCostDocumentsOther({
        count: state.otherOptions.itemsPerPage,
        page: state.otherOptions.page - 1,
        criterions: _.cloneDeep(state.otherFilters),
        filterName: state.filterName,
      });
      commit.setOtherList(response);
      commit.setIsOtherLoading(false);
      if (response.items.length > 0) commit.setSelectedOther(response.items[0]);
    },
    async getCostDocumentOtherItems(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.selectedOther) {
        commit.setIsOtherItemsLoading(true);
        const response = await getCostDocumentOtherItems(state.selectedOther.id);
        commit.setOtherItems(response);
        commit.setIsOtherItemsLoading(false);
      }
    },
    async getCostDocumentOtherFiles(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.selectedOther) {
        commit.setOtherFiles(null);
        const response = await getCostDocumentOtherFiles(state.selectedOther.id);
        commit.setOtherFiles(response);
      }
    },
    async getCostDocumentOtherDetails(context, costDocumentId) {
      const { commit } = _moduleActionContext(context);
      commit.setOtherDetails(null);
      const details = await getCostDocumentOtherDetails(costDocumentId);
      commit.setOtherDetails(details);
    },
    async deleteCostDocumentOther(context, costDocumentId) {
      const { dispatch, rootDispatch } = _moduleActionContext(context);
      const confirmation = await rootDispatch.popup.addConfirm({
        title: filterCapitalize(i18n.t("warning").toString()),
        content: filterCapitalize(i18n.t("doYouReallyWantToDeleteCostDocument?").toString()),
        width: undefined,
        customButtons: null,
      });
      if (confirmation) {
        await rootDispatch.failIfRequestsInProgress();
        const result = await removeCostDocumentOther(costDocumentId, false);

        await DoubleConfirm.Process(result, rootDispatch.popup.addConfirm, async () => {
          await removeCostDocumentOther(costDocumentId, true);
        });
      }
      await dispatch.getCostDocumentsOther();
    },
    async approveCostDocument(context, costDocumentId) {
      const { dispatch, rootDispatch } = _moduleActionContext(context);
      if (
        await rootDispatch.popup.addConfirm(
          new ConfirmModel(
            filterCapitalize(i18n.t("areYouSureYouWantToApproveThisDocument")),
            filterCapitalize(i18n.t("warning")),
            [
              {
                text: filterCapitalize(i18n.t("no")),
                color: "warning",
                value: false,
                outlined: true,
              },
              {
                text: filterCapitalize(i18n.t("yes")),
                color: "warning",
                value: true,
              },
            ],
            "450px"
          )
        )
      ) {
        await approveCostDocumentOther(costDocumentId);
        await dispatch.getCostDocumentsOther();
        await rootDispatch.popup.addSavedOkSnackbar();
      }
    },
    async approveCostDocuments(context) {
      const { dispatch, rootDispatch, state } = _moduleActionContext(context);
      if (
        await rootDispatch.popup.addConfirm(
          new ConfirmModel(
            filterCapitalize(i18n.t("areYouSureYouWantToApproveThisDocuments")) +
              " - <b>" +
              state.otherMarked.map((x) => x.documentNumber).join(", ") +
              "</b>",
            filterCapitalize(i18n.t("warning")),
            [
              {
                text: filterCapitalize(i18n.t("no")),
                color: "warning",
                value: false,
                outlined: true,
              },
              {
                text: filterCapitalize(i18n.t("yes")),
                color: "warning",
                value: true,
              },
            ],
            "450px"
          )
        )
      ) {
        const costDocumentIds = state.otherMarked.map((x) => x.id);
        await approveCostDocumentsOther(costDocumentIds);
        await dispatch.getCostDocumentsOther();
        await rootDispatch.popup.addSavedOkSnackbar();
      }
    },
    async changePayer(context, contractorId) {
      const { rootDispatch, dispatch, state } = _moduleActionContext(context);
      const costDocumentIds = state.otherMarked.map((x) => x.id);
      await changePayer(contractorId, costDocumentIds);
      await dispatch.getCostDocumentsOther();
      await rootDispatch.popup.addSavedOkSnackbar();
    },
    async returnCostDocumentToBuffer(context, costDocumentId: string) {
      const { dispatch, rootDispatch } = _moduleActionContext(context);

      if (
        await rootDispatch.popup.addConfirm(
          new ConfirmModel(
            filterCapitalize(i18n.t("areYouSureYouWantToReturnThisDocumentToBuffer")),
            filterCapitalize(i18n.t("warning")),
            [
              {
                text: filterCapitalize(i18n.t("no")),
                color: "warning",
                value: false,
                outlined: true,
              },
              {
                text: filterCapitalize(i18n.t("yes")),
                color: "warning",
                value: true,
              },
            ],
            "450px"
          )
        )
      ) {
        await assignCostDocument(costDocumentId, COST_DOCUMENT_TYPES.Undefined);
        await dispatch.getCostDocumentsOther();
        await rootDispatch.popup.addSavedOkSnackbar();
      }
    },
    async changeScamStatus(context, { costDocumentId, reason, setToScam }) {
      const { dispatch, rootDispatch } = _moduleActionContext(context);
      if (setToScam) await setStatusToScam(costDocumentId, reason);
      else await cancelScamStatus(costDocumentId, reason);
      await dispatch.getCostDocumentsOther();
      await rootDispatch.popup.addSavedOkSnackbar();
    },
    async addFilteredOther(context) {
      const { dispatch, commit, state } = _moduleActionContext(context);
      await dispatch.getCostDocumentsOther();
      commit.setIsOtherLoading(true);
      const response = await getCostDocumentsOtherFiltered({
        count: state.otherOptions.itemsPerPage,
        page: state.otherOptions.page - 1,
        criterions: _.cloneDeep(state.otherFilters),
        filterName: state.filterName,
      });
      commit.setOtherMarked(response);
      commit.setIsOtherLoading(false);
    },
    async downloadServiceTypes(context) {
      const { commit } = _moduleActionContext(context);
      commit.setServiceTypes(await getServiceTypesSimple(SERVICE_CATEGORY.Cost));
    },
    async changeCategory(context, serviceTypeId: number) {
      const { dispatch, state } = _moduleActionContext(context);
      if (state.otherMarked.length === 0) return;
      const costDocumentIds = state.otherMarked.map((x) => x.id);
      await changeCategory(serviceTypeId, costDocumentIds);
      await dispatch.getCostDocumentsOther();
    },
  },
});

export default CostDocumentsOtherModule;

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
const _moduleGetterContext = (args: [any, any, any, any]) =>
  moduleGetterContext(args, CostDocumentsOtherModule);
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, CostDocumentsOtherModule);
